export default "__VITE_ASSET__BZHtSWUj__"